import { useState, useEffect } from 'react';
import { CLIENTS } from "./../api/config/config";
export const useConversationMeta = (conversationId, initialTotalMessages) => {
  const {
    twilioClient
  } = CLIENTS;
  const [totalMessages, setTotalMessages] = useState(initialTotalMessages);
  const updateTotalMessages = async convo => {
    const {
      items
    } = await convo.getMessages();
    const newTotal = items.length - 1;
    setTotalMessages(newTotal);
  };
  useEffect(() => {
    setTotalMessages(initialTotalMessages);
    let twilioConversation = null;
    const onMessageAdded = async () => {
      await updateTotalMessages(twilioConversation);
    };
    const callBacks = async () => {
      twilioConversation = await twilioClient.getConversationBySid(conversationId);
      twilioConversation.on('messageAdded', onMessageAdded);
    };
    callBacks();
    return () => {
      if (twilioConversation) {
        twilioConversation.removeListener('messageAdded', onMessageAdded);
      }
    };
  }, [conversationId, twilioClient, initialTotalMessages]);
  return {
    totalMessages
  };
};
//# sourceMappingURL=useConversationMeta.js.map